import { getStore } from "../store/store";

export function getIsMainAppHeightOverflow(): boolean {
    return getStore().isMainAppHeightOverflow;
}

export function getMainAppMinHeight(): string | null {
    return getStore().mainAppMinHeight;
}
